// react
import React from 'react';

// mui
import { Alert, AlertColor, Box, Stack } from '@mui/material';

// components
import { Logo } from '@/components/atoms/Logo/Logo';
import { PageHeader } from '@/pwa/atoms/PageHeader/PageHeader';

// mui
import { Button } from '@mui/material';

const variantMap = {
  primary: 'contained',
  secondary: 'outlined',
  link: 'text',
} as const;

export interface FloatingContentAction {
  label: string;
  variant: 'primary' | 'secondary' | 'link';
  onClick: () => void;
}

export interface FloatingContentAlert {
  severity: AlertColor;
  message: string;
}

interface FloatingContentProps {
  children?: React.ReactNode;
  title: string;
  description?: string;
  alert?: FloatingContentAlert;
  actions?: FloatingContentAction[];
  isLogo?: boolean;
}
/**
 * FloatingContent shows a PageHeader along with a children slot, and action
 * buttons.
 */
export const FloatingContent = ({
  children,
  title,
  description,
  alert,
  actions,
  isLogo = false,
}: FloatingContentProps) => {
  return (
    <Stack
      sx={{
        gap: 4,
      }}
    >
      {isLogo && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Logo variant='symbol' />
        </Box>
      )}
      <PageHeader title={title} description={description} isCentered />
      {alert && <Alert severity={alert.severity}>{alert.message}</Alert>}
      {children}
      <Stack
        sx={{
          gap: 2,
        }}
      >
        {actions?.map((action, index) => (
          <Button
            key={index}
            aria-label={action.label}
            variant={variantMap[action.variant]}
            onClick={action.onClick}
          >
            {action.label}
          </Button>
        ))}
      </Stack>
    </Stack>
  );
};

FloatingContent.displayName = 'FloatingContent';
export default FloatingContent;
